export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13826.05b960b3.jpg";